import { select, takeLatest } from 'redux-saga/effects';

import { DeductionActions } from '../constants';
import { DeductionApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import { DeleteDeductionAction, GetDeductionAction, GetDeductionsAction } from '../actions/deduction-actions';
import sortingService from '../../services/sorting';
import { handleError, resolveApiCall, ResolverApiFailure } from '../../services/api-handlers/api-resolver';

function* handleFetchDeductions(action: GetDeductionsAction) {
    const oldData = yield select((state: StoreState) => state.deductions.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        DeductionApi.getDeductions({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchDeduction(action: GetDeductionAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => DeductionApi.getDeduction(id));
}

function* handleDeleteDeduction(action: DeleteDeductionAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => DeductionApi.deleteDeduction(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(DeductionActions.FETCH_DEDUCTIONS, handleFetchDeductions);
    yield takeLatest(DeductionActions.FETCH_DEDUCTION, handleFetchDeduction);
    yield takeLatest(DeductionActions.DELETE_DEDUCTION, handleDeleteDeduction);
}
